import {Component, Vue} from 'vue-property-decorator';

@Component
export default class RestockDetailDataMixin extends Vue {

  // 발송여부
  public sendType: 'ALL' | 'SEND' | 'NOT_YET_SEND' = 'ALL';

  // 상품정보 grid
  public basicGridInfo: any = {
    contents: [],
    props: {
      columns: [
        {
          header: this.$t('COMMON_MALL'),
          name: 'mallName',
          align: 'center',
          minWidth: 120
        },
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_PARTNER'),
          name: 'partnerName',
          align: 'center',
          minWidth: 100
        },
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_PRODUCT_NO'),
          name: 'productNo',
          align: 'center',
          minWidth: 120,
          formatter: ({row, value}): string => `<a href="${row.url}" target="_blank">${value}</a>`
        },
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_PRODUCT_NAME'),
          name: 'productName',
          align: 'center',
          minWidth: 110
        },
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_OPTION_NO'),
          name: 'optionNo',
          align: 'center',
          minWidth: 150
        },
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_OPTION_NAME_AND_VALUE'),
          name: 'optionName',
          align: 'center',
          minWidth: 200,
          formatter: ({ row, value }): string => {
            const {optionType, optionValue} = row;
            if (!optionType) return this.$t('PRODUCT_RESTOCK_DELETED_OPTION') as string;
            return optionType === 'DEFAULT' ? '-' : `${value}:${optionValue}`;
          }
        },
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_RESERVATION_INVENTORY'),
          name: 'reservationStockCount',
          align: 'center',
          width: 80,
          formatter: ({ row }): string => row.reservationStockCount ?? '-'
        },
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_INVENTORY'),
          name: 'stockCount',
          align: 'center',
          width: 80,
          formatter: ({ row }): string => row.stockCount ?? '-'
        },
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_SALES_STATUS'),
          name: 'saleStatusType',
          align: 'center',
          minWidth: 100,
          formatter: ({ value }): string => value ? this.$t(`PRODUCT_RESTOCK_${value}`) as string : '-',
        },
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_SALES_SETUP'),
          name: 'saleSettingStatusType',
          align: 'center',
          minWidth: 100,
          formatter: ({value}): string => value ? this.$t(`PRODUCT_RESTOCK_${value}`) as string : '-',
        },
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_OPTION_AVAILABILITY'),
          name: 'useOption',
          align: 'center',
          width: 80,
          formatter: ({row, value}): string => {
            if (!row.optionType) return '-';

            return value ? 'Y' : 'N';
          }
        },
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_PRE_SALE_PERIOD'),
          name: 'reservationPeriod',
          align: 'center',
          minWidth: 280,
          formatter: ({ value }): string => `${value ? value.startYmdt : ''} ~ ${value ? value.endYmdt : ''}`
        },
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_SALE_PERIOD'),
          name: 'salePeriod',
          align: 'center',
          minWidth: 280,
          formatter: ({ value }): string => `${value.startYmdt} ~ ${value.endYmdt}`
        },
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_EXHIBIT_STATUS'),
          name: 'frontDisplayable',
          align: 'center',
          minWidth: 100,
          formatter: ({value}): string => this.$t(`PRODUCT_RESTOCK_CAN${value ? '' : '_NOT'}_DISPLAY`) as string
        }
      ]
    },
    options: {
      name: 'grid',
      haveConfigBtn: false,
      haveExcelDownBtn: false,
      onLoadSearch: false,
      scrollY: false,
      isInitialRequest: true,
      nonDataBodyHeight: 34,
      haveDataBodyHeight: 34,
      header: {
        height: 33
      },
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0
      }
    },
    gridOption: {
      name: 'basic-info-grid',
      haveRigthBtn: false,
      haveConfigBtn: false,
      haveExcelDownBtn: false,
      nonDataBodyHeight: 100,
      haveDataBodyHeight: 34,
      onLoadSearch: false,
      isInitialRequest: true,
    }
  };

  // 조회결과 grid
  public restockGridInfo = {
    contents: [],
    props: {
      columns: [
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_DATE_OF_APPLICATION'),
          name: 'registerDateTime',
          align: 'center'
        },
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_REQUEST_USER'),
          name: 'name',
          align: 'center',
          formatter: ({row, value}): string => `${row.memberNo ? `<button class="js-btn-member-name" type="button" data-member-no="${row.memberNo}">${value}</button>` : value}`
        },
        {
          header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_PHONE'),
          name: 'phone',
          align: 'center'
        },
        {
          header: this.$t('PRODUCT_RESTOCK_SEND_OR_NOT'),
          name: 'isSent',
          align: 'center',
          formatter: ({value}): string => this.$t(`PRODUCT_RESTOCK_${value ? 'SEND' : 'NOT_YET_SEND'}`) as string
        }
      ],
      options: {
        columnOptions: {
          resizable: true,
          minWidth: 50
        },
        rowHeaders: ['checkbox'],
        header: {
          height: 33
        },
        displayRowCount: 20,
        minRowHeight: 31,
        isInitialRequest: true,
        pageOptions: {
          perPage: 30,
          page: 1,
          totalCount: 0
        }
      }
    },
    gridOption: {
      name: 'restock-info-grid',
      haveConfigBtn: false,
      haveExcelDownBtn: false,
      onLoadSearch: false,
    }
  };
}

